import { jsx as c } from "react/jsx-runtime";
import m from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as l } from "react";
const h = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "7 7 18 18", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.929 15.036A1.93 1.93 0 0 1 7 13.107V8.93C7 7.863 7.863 7 8.929 7h4.178c1.065 0 1.929.863 1.929 1.929v4.178a1.93 1.93 0 0 1-1.929 1.929zm8.035 3.934c0-1.108.898-2.006 2.006-2.006h4.024c1.108 0 2.006.898 2.006 2.006v4.024A2.006 2.006 0 0 1 22.994 25H18.97a2.006 2.006 0 0 1-2.006-2.006zM8.93 25A1.93 1.93 0 0 1 7 23.071v-4.178c0-1.065.863-1.929 1.929-1.929h4.178c1.065 0 1.929.864 1.929 1.929v4.178A1.93 1.93 0 0 1 13.107 25zm8.035-11.893c0 1.065.864 1.929 1.929 1.929h4.178A1.93 1.93 0 0 0 25 13.107V8.93A1.93 1.93 0 0 0 23.071 7h-4.178a1.93 1.93 0 0 0-1.929 1.929z", clipRule: "evenodd" })), a = /* @__PURE__ */ l(({ size: e = "inherit", sx: o, ...r }, n) => {
  const i = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ c(m, {
    ...r,
    ref: n,
    component: h,
    inheritViewBox: !0,
    sx: i
  });
});
a.displayName = "svg_other";
export {
  a as default
};
